export default __webpack_public_path__ + "euro-currency-symbol.png";